document.addEventListener('DOMContentLoaded', function() {
  let splide1, splide2, splide3, splide4;

  // シャッフル処理を行う関数
  function shuffleElements(containerSelector) {
    const container = document.querySelector(containerSelector + ' .splide__list'); // <li> 要素が入っているリストを取得
    const items = Array.from(container.children); // <li> 要素を配列に変換
    const shuffledItems = shuffle(items); // シャッフル

    shuffledItems.forEach(item => container.appendChild(item)); // シャッフルされた要素を再度追加
  }

  // 配列をシャッフルする関数
  function shuffle(arrays) {
    const array = arrays.slice();
    for (let i = array.length - 1; i >= 0; i--) {
      const randomIndex = Math.floor(Math.random() * (i + 1)); // ランダムなインデックスを生成
      [array[i], array[randomIndex]] = [array[randomIndex], array[i]]; // 要素を入れ替え
    }
    return array;
  }


  if (document.querySelector('.p-top .splide.splide1')) {
    shuffleElements('.p-top .splide.splide1'); // シャッフル処理
      splide1 = new Splide('.splide.splide1', {
        type: 'loop',
        autoWidth: true,
        perPage: 3,
        autoplay: true,
        pagination : false,
        speed: 2000,
        interval: 2000,
        arrows: false,
        // pauseOnHover: true,
      },);

      splide1.mount();
  }
  if (document.querySelector('.p-top .splide.splide2')) {
    shuffleElements('.p-top .splide.splide2'); // シャッフル処理
      splide2 = new Splide('.splide.splide2', {
        type: 'loop',
        autoWidth: true,
        perPage: 3,
        autoplay: true,
        pagination: false,
        speed: 2000,
        interval: 2000,
        arrows: false,
        // pauseOnHover: true,
      },);
      splide2.mount();
  }
  if (document.querySelector('.p-pageGokain .splide.splide1')) {
    shuffleElements('.p-pageGokain .splide.splide1'); // シャッフル処理
      splide3 = new Splide('.splide.splide1', {
        type: 'loop',
        autoWidth: true,
        perPage: 3,
        autoplay: true,
        pagination : false,
        speed: 2000,
        interval: 2000,
        arrows: false,
        // pauseOnHover: true,
      },);

      splide3.mount();
  }
  if (document.querySelector('.p-pageGokain .splide.splide2')) {
    shuffleElements('.p-pageGokain .splide.splide2'); // シャッフル処理
      splide4 = new Splide('.splide.splide2', {
        type: 'loop',
        autoWidth: true,
        perPage: 3,
        autoplay: true,
        pagination: false,
        speed: 2000,
        interval: 2000,
        arrows: false,
        // pauseOnHover: true,
      },);
      splide4.mount();
  }

  const stopAllSliders01 = () => {
    if (splide1) splide1.Components.Autoplay.pause(); //Splide.js の一時停止内部メソッド
    if (splide2) splide2.Components.Autoplay.pause();
  };
  
  const startAllSliders01 = () => {
    if (splide1) splide1.Components.Autoplay.play();
    if (splide2) splide2.Components.Autoplay.play();
  };

  const stopAllSliders02 = () => {
    if (splide3) splide3.Components.Autoplay.pause(); //Splide.js の一時停止内部メソッド
    if (splide4) splide4.Components.Autoplay.pause();
  };
  
  const startAllSliders02 = () => {
    if (splide3) splide3.Components.Autoplay.play();
    if (splide4) splide4.Components.Autoplay.play();
  };
  
  document.querySelectorAll('.splide').forEach(splide => {
    splide.addEventListener('mouseenter', stopAllSliders01);
    splide.addEventListener('mouseleave', startAllSliders01);
  });

  document.querySelectorAll('.splide').forEach(splide => {
    splide.addEventListener('mouseenter', stopAllSliders02);
    splide.addEventListener('mouseleave', startAllSliders02);
  });

  // Intersection Observer のコールバック関数
  const observerCallback = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 要素がビューポート内に入った場合
        if (entry.target.classList.contains('splide1') || entry.target.classList.contains('splide2')) {
          startAllSliders01();
        }
        if (entry.target.closest('.p-pageGokain')) {
          startAllSliders02();
        }
      } else {
        // 要素がビューポート外に出た場合
        if (entry.target.classList.contains('splide1') || entry.target.classList.contains('splide2')) {
          stopAllSliders01();
        }
        if (entry.target.closest('.p-pageGokain')) {
          stopAllSliders02();
        }
      }
    });
  };

  // Intersection Observer のオプション
  const observerOptions = {
    root: null, // ビューポートを基準
    rootMargin: '0px',
    threshold: 0.1 // 10% 見えたら発火
  };

  // Intersection Observer のインスタンスを作成
  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // 各 splide 要素に対して Intersection Observer を設定
  document.querySelectorAll('.splide').forEach(splide => {
    observer.observe(splide);
  });

});









